// @ts-expect-error - TS2614 - Module '"apollo-client"' has no exported member 'NetworkStatusRaw'. Did you mean to use 'import NetworkStatusRaw from "apollo-client"' instead?
// eslint-disable-next-line no-restricted-imports -- we need to use apollo-client for this
import type {NetworkStatusRaw} from "apollo-client";

import {Errors, KAError} from "@khan/logging";

const networkStatus = Object.freeze({
    loading: 1,
    setVariables: 2,
    fetchMore: 3,
    refetch: 4,
    // unused: 5,
    poll: 6,
    ready: 7,
    error: 8,
});
export default networkStatus;

export type NetworkStatus = (typeof networkStatus)[keyof typeof networkStatus];

export function fromApolloNetworkStatus(
    apolloNetworkStatus: NetworkStatusRaw,
): NetworkStatus {
    switch (apolloNetworkStatus) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
        case 7:
        case 8:
            return apolloNetworkStatus;

        default:
            throw new KAError(
                "Unsupported network status value",
                Errors.Internal,
            );
    }
}
